import env from '@/config/env';
import TabelaImportacao from '@/graphql/tabela/queries/TabelaImportacao.gql';
import TabelaRenova from '@/graphql/tabela/queries/TabelaRenova.gql';

export const Types = {
  TABELA_ADD: 'TABELA_ADD',
  TABELA_RENOVA: 'TABELA_RENOVA',
  TABELA_CLEAR: 'TABELA_CLEAR',
};

export default {
  namespaced: true,
  state: {
    tabela: null,
    renova: null,
  },
  getters: {
    tabela: state => state.tabela,
    renova: state => state.renova,
  },
  mutations: {
    [Types.TABELA_ADD](state, payload) {
      state.tabela = payload.tabela;
    },
    [Types.TABELA_RENOVA](state, payload) {
      state.renova = payload.renova;
    },
    [Types.TABELA_CLEAR](state) {
      state.tabela = null;
      state.renova = null;
    },
  },
  actions: {
    async getImportacao({ commit, dispatch }, uf) {
      try {
        const query = await env.tabela.query({
          query: TabelaImportacao,
          variables: {
            uf,
          },
        });

        const [imp] = query.data.importacao;
        await dispatch('getRenova', uf);
        commit(Types.TABELA_ADD, { tabela: imp.id });
      } catch (e) {
        dispatch(
          'error/setError',
          {
            message: 'Não foi possível localizar uma tabela de preço para UF.',
          },
          { root: true },
        );
      }
    },
    async getRenova({ commit, dispatch }, uf) {
      const query = await env.tabela.query({
        query: TabelaRenova,
        variables: {
          uf,
        },
        fetchPolicy: 'no-cache',
      });

      try {
        const [imp] = query.data.importacao;
        commit(Types.TABELA_RENOVA, { renova: imp.id });
        return imp.id;
      } catch (e) {
        dispatch(
          'error/setError',
          {
            message: 'Não foi possível localizar a tabela renova para UF.',
          },
          { root: true },
        );
      }
    },
    clearImportacao({ commit }) {
      commit(Types.TABELA_CLEAR);
    },
  },
};
